import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBar from "../../../common/AppBar";
import AppTable from "../../../common/AppTable/AppTable";
import FilterDropdown from "../../../common/AppSpecificConpnents/PartsTable/FilterDropdown";
import ActionItemFilterData from "./ActionItemFilterData";
import { fetchAllActionItems, fetchReassignedTasks, openTaskPopup, setActionItemId, fetchActionItemsWithFilter } from "../../../redux/taskSlice";
import Loader from "../../../common/Loader";
import { formatDueDate, renderUser } from "../Uitlities";
import { TableActionGroup } from "../../../common/Buttons";
import { useLocation, useNavigate } from "react-router-dom";

const ActionItem = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleStateClear = () => {
    if (location.state?.filter) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  };
  const { action_items, counts_in_filter, pagination, loading } = useSelector((state) => state.task);
  const tableContainerRef = useRef();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  
  // Define table columns based on the image
  const columns = [
    {
      headName: "Pinned",
      field: "is_pinned",
      sort: false,
      filter: false,
      width: "80px",
      textCenter: true,
    },
    {
      headName: "Assigned To",
      field: "assigned_to",
      sort: true,
      filter: true,
      width: "150px",
    },
    {
      headName: "Task",
      field: "task",
      sort: true,
      filter: true,
      width: "300px",
    },
    {
      headName: "Note",
      field: "note",
      sort: true,
      filter: true,
      width: "200px",
    },
    {
      headName: "Owner",
      field: "owned_by_user",
      sort: true,
      filter: true,
      width: "150px",
    },
    {
      headName: "Status",
      field: "status",
      sort: true,
      filter: true,
      width: "120px",
    },
    {
      headName: "Due Date",
      field: "due",
      sort: true,
      filter: true,
      width: "100px",
    },
    {
      headName: "Action",
      field: "action",
      width: "100px",
      textCenter: true,
      isAction: true
    },
  ];

  // useEffect(() => {
  //   if (location.state?.filter) {
  //     const redirectFilter = location.state.filter;
  //     if (redirectFilter.includes("is_reassigned")) {
  //       dispatch(fetchReassignedTasks({ queryParams: "is_reassigned=true" }));
  //     } else {
  //       dispatch(fetchActionItemsWithFilter({ filter: redirectFilter }));
  //     }
  //   }
  // }, [location.state, dispatch]);

  // Handle filter change and fetch tasks
  useEffect(() => {
    if (location.state?.filter) return;
    let timer = setTimeout(() => {
      if (searchQuery.length) {
        // Add is_system_gen=true to the search query
        let query = searchQuery;
        if (!query.includes("is_system_gen=")) {
          query += `&is_system_gen=true`;
        }
        if (filterType && filterType !== "all") {
          query += filterType;
          if (filterType.includes("is_reassigned")) {
            query += `&is_system_gen=false`;
          }
        }
        if (query.includes("is_reassigned")) {
          dispatch(fetchReassignedTasks({ queryParams: "is_reassigned=true" }))
        } else {
          if(query.includes("assign_to") || query.includes("owned_by")){
            query = query.replace("&is_system_gen=true", "");
            query += `&is_system_gen=false`; 
          }
          dispatch(fetchAllActionItems({ searchQuery: query }));
        }
      }
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, searchQuery, filterType]);

  return (
    <div>
      {/* {loading && <Loader text="Loading action items..." />} */}
      <AppBar
        title="Action Items"
        showTablesDropdown={false}
        buttons={[]}
        showProfileButton={true}
        showBlackTitle={true}
      />

      <AppTable
        ref={tableContainerRef}
        columnsData={columns}
        showSearchInput={true}
        searchInputPosition="center"
        contentBeforeSearchFilter={
          <>
            <FilterDropdown
              filterOptions={ActionItemFilterData(counts_in_filter)}
              filterType={filterType}
              setFilterType={(type) => {
                setFilterType(type);
                handleStateClear();
              }}
              disableFilter={false}
            />
          </>
        }
        paginate={true}
        pagination={{
          limit: [limit, setLimit],
          offset: [offset, setOffset],
          pagination,
          maxVsbleButtons: 7,
          paginationPosition: {
            position: "right",

          },
          paginationShadow: true,
        }}
        onFilterSortHandler={(query) => {
          setSearchQuery(query);
          handleStateClear();
        }}
        usingInPopup={false}
      >
        {action_items && action_items.length > 0 ? (
          action_items.map((row, index) => (
            <tr key={row.task_id || index}>
              <td style={{ textAlign: "center", }}>
                <input
                  type="checkbox"
                  checked={row.is_pinned || false}
                  readOnly
                />
              </td>
              <td>
                {renderUser(row.assigned_user)}
              </td>
              <td>
                {row.task}
              </td>
              <td>
                {row.note}
              </td>
              <td>
                {renderUser(row.owned_by_user)}
              </td>
              <td>
                {row.status}
              </td>
              <td>
                {formatDueDate(row.due)}
              </td>
              <td style={{ textAlign: "center", }}>
                <TableActionGroup
                  mode="view"
                  showEdit={false}
                  showDelete={false}
                  showSelect={true}
                  onSelect={() => {
                    // Set action_item_id
                    dispatch(setActionItemId(row.task_id));
                    dispatch(openTaskPopup());
                  }}
                />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length} style={{ textAlign: "center", padding: "20px" }}>
              No data available
            </td>
          </tr>
        )}
      </AppTable>
    </div>
  );
};

export default ActionItem;

